import React from "react";
import Ripple from "../../../Ripple";
import withState from "../../../../../utils/withState";

module.exports = withState((setState, self, onMount) => {
  const {setActiveId, activeId: defaultID} = self.props;

  self.state = {
    ...self.state,
    activeId: defaultID
  }

  const moveBorder = (id) => {
    const node = document.getElementById(id);

    if (!node) return;

    setState({width: node.offsetWidth, left: node.offsetLeft});
  };

  const onClick = (activeId) => () => {
    moveBorder(activeId);
    setState({activeId})
    setTimeout(() => {
      setActiveId(activeId);
    }, 250);
  }

  onMount(() => {
    setTimeout(() => {
      moveBorder(defaultID);
    });
  })

  return ((state, props) => {
    const {activeId, width, left} = state;
    const {tabsData} = props;

    return (
      <div className="h75 mh-45">
        <div className="rlv layoutRow aiC mh-20 ph45 b0 bb2 bs bc505255">
          {Object.keys(tabsData).map((id) => (
            <Ripple
              id={id}
              key={id}
              className={
                'layoutRow jcC aiC h73 ph20 cA4A7AC (cF).active'
                + (activeId === id ? ' active' : '')
              }
              onClick={onClick(id)}
            >
              {tabsData[id].title || ''}
            </Ripple>
          ))}
          <div
            className="h2 abs sb bgF"
            style={{width, left, transition: '.25s'}}
          />
        </div>
      </div>
    )
  })
});
